import { Slider } from './components/slider.js';

document.querySelectorAll('[data-href]').forEach((divLink: HTMLElement) => {
    divLink.onclick = (): void => {
        window.location.href = divLink.dataset.href;
    };
});

document.querySelectorAll('.video').forEach((video: HTMLElement) => {
    const img = video.querySelector('.youtube-thumb')
    if (img) {
        img.addEventListener('click', () => {
            img.nextElementSibling.src = img.nextElementSibling.dataset.src;
            img.classList.add('is-hidden')
        })
    }
});

const sidebarTrigger = document.querySelector('.sidebar-trigger');
if (sidebarTrigger) {
    sidebarTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        sidebarTrigger.classList.toggle('is-active');
    });
}

